import { useRef, useState } from 'react';
import { Radio } from '@quero-delivery/quero-components-web';
import debounce from 'lodash/debounce';
import { toast } from 'react-toastify';

import styles from './styles.module.scss';

import useRequest from '@/hooks/util/useRequest';
import Requests from '@/Services/Requests';
import type { Place } from '@/_types/places';

interface IProps {
  place: Place;
}

function FareType({ place }: IProps) {
  const [isPlaceFareActived, setIsPlaceFareActived] = useState(
    !!place.isPlaceFareActive,
  );

  const debounceUpdateIsPlaceFareActived = useRef(
    debounce(updateIsPlaceFareActived, 500),
  );

  const { request } = useRequest();

  function toggleIsPlaceFareActived() {
    setIsPlaceFareActived(!isPlaceFareActived);

    debounceUpdateIsPlaceFareActived.current(!isPlaceFareActived);
  }

  async function updateIsPlaceFareActived(isPlaceFareActived: boolean) {
    try {
      const response = await request(
        Requests.places.updateIsPlaceFareActive(place._id, isPlaceFareActived),
      );

      if (!response?.r) {
        toast.warn(response?.errors.join(' - '));
      }
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (err: any) {
      const errorMessage = err.response?.data.error;
      toast.error(errorMessage);
    }
  }

  return (
    <div className={styles.fareType}>
      <Radio
        sizeBox="md"
        label="Tarifa cidade"
        onChange={() => {
          if (isPlaceFareActived) {
            toggleIsPlaceFareActived();
          }
        }}
        checked={!isPlaceFareActived}
      />

      <Radio
        sizeBox="md"
        label="Tarifa estabelecimento"
        onChange={() => {
          if (!isPlaceFareActived) {
            toggleIsPlaceFareActived();
          }
        }}
        checked={isPlaceFareActived}
        disabled={!place.placeFare}
      />
    </div>
  );
}

export default FareType;
